import { browserTracingIntegration, init as sentryInit } from '@sentry/react';
import { configureApi } from 'isc-shared/api';
import { configureAuth } from 'isc-shared/auth';
import AuthProvider from 'isc-shared/auth/Provider';
import PressedKeysProvider from 'isc-shared/contexts/pressed-keys/Provider';
import 'isc-shared/styles/global.css';
import NotifierProvider from 'isc-shared/ui/notifier/Provider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './layouts/global.css';
import env from './lib/env';
import { router } from './lib/routing';

const IS_PRODUCTION = env('MODE') === 'production'; // NOTE: This includes staging!
const IS_STAGING = Boolean(env('VITE_STAGING', false));

if (IS_PRODUCTION) {
    sentryInit({
        dsn: "https://48a8001a455e49b8a421057186d145fe@o283657.ingest.sentry.io/4505160342306816",
        integrations: [browserTracingIntegration()],
        environment: IS_STAGING ? 'staging': 'production',
        release: VITE_BUILD_TIMESTAMP,
    });
}

const root = document.getElementById('root');

if (!root) {
    throw new Error('No #root element found.');
}

configureApi(import.meta.env.VITE_API_ROOT);
configureAuth(
    import.meta.env.VITE_IDENTITY_SERVICE_ORIGIN,
    import.meta.env.VITE_IDENTITY_SERVICE_CLIENT_ID
);

ReactDOM.createRoot(root).render(
    <React.StrictMode>
        <PressedKeysProvider>
            <NotifierProvider>
                <AuthProvider>
                    <RouterProvider router={router} />
                </AuthProvider>
            </NotifierProvider>
        </PressedKeysProvider>
    </React.StrictMode>,
);
